import * as actionTypes from '../actions/actionTypes';

const initialState = {
    states: null,
    loading: false
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_STATES_SUCCESS:
            return {
                ...state,
                states: action.states
            }
        case actionTypes.FETCH_STATES_FAILURE:
            return {
                ...state
            }
        default:
            return state;
    }
}

export default reducer;